import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "p-5" };
const _hoisted_3 = { class: "columns is-variable is-5" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "column is-narrow" }, [
    /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle mb-4" }, "Citizens"),
    /*#__PURE__*/ _createElementVNode("h3", null, "The citizens under your care")
], -1);
const _hoisted_5 = {
    key: 1,
    class: "ml-5 mt-5"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "column" }, null, -1);
const _hoisted_8 = { class: "column is-narrow" };
const _hoisted_9 = { class: "field" };
const _hoisted_10 = { class: "control" };
const _hoisted_11 = { class: "table is-hoverable is-fullwidth" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("th", { style: { "min-width": "30%" } }, "Citizen Name", -1);
const _hoisted_13 = { key: 0 };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("th", null, "Site", -1);
const _hoisted_15 = { key: 1 };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("th", null, "Registered", -1);
const _hoisted_17 = { key: 0 };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("td", {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
}, "Select a partner", -1);
const _hoisted_19 = [
    _hoisted_18
];
const _hoisted_20 = { key: 1 };
const _hoisted_21 = { key: 2 };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("td", {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
}, "No results", -1);
const _hoisted_23 = [
    _hoisted_22
];
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { class: "horizontal" };
const _hoisted_26 = { key: 1 };
const _hoisted_27 = { class: "adaptiveLabel" };
const _hoisted_28 = { key: 4 };
const _hoisted_29 = {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
};
import { useAsync } from "@/composables/useAsync";
import { useFilterForAsync } from "@/composables/useFilter";
import { isFeatureEnabled, isNetworkAdmin, isPartnerAdmin, sessionState } from "@/core/session";
import { formatDateShort, notifyNetworkError } from "@/core/utils";
import { ref, watch } from "vue";
import { apiCitizens } from "./api";
import PartnerSelectField from "@/features/partners/PartnerSelectField.vue";
import { User, Core } from "@minicity/core";
import { apiPartners } from "../partners/api";
import { CONFIG } from "@/core/config";
const LIMIT_SIZE = 150;
export default /*#__PURE__*/ _defineComponent({
    __name: 'CitizenListingPanel',
    setup(__props) {
        const citizens = useAsync();
        const citizenJoinUrl = ref();
        const loadCitizenJoinUrl = (partnerId) => {
            citizenJoinUrl.value = null;
            if (!partnerId)
                return;
            apiPartners.get(partnerId)
                .then(p => {
                var _a;
                citizenJoinUrl.value = `${(_a = CONFIG.value) === null || _a === void 0 ? void 0 : _a.citizenOnboardingUrl.replace('#PAIRING_CODE#', p.pairingCode)}`;
            });
        };
        // Fetch citizens from API
        if (sessionState.session) {
            switch (sessionState.session.user.role) {
                case User.Role.NETWORK_ADMIN: {
                    citizens.fetch(apiCitizens.getForNetwork()).catch(err => { notifyNetworkError("Failed to load citizens", err); });
                    break;
                }
                case User.Role.PARTNER_ADMIN: {
                    citizens.fetch(apiCitizens.getForPartner(sessionState.session.partnerId)).catch(err => { notifyNetworkError("Failed to load citizens", err); });
                    loadCitizenJoinUrl(sessionState.session.partnerId);
                    break;
                }
                case User.Role.PARTNER_USER: {
                    citizens.fetch(apiCitizens.getForCaseworker(sessionState.session.partnerId, sessionState.session.user.id)).catch(err => { notifyNetworkError("Failed to load citizens", err); });
                    loadCitizenJoinUrl(sessionState.session.partnerId);
                    break;
                }
                default:
                    console.error("Unexpected user type");
                    break;
            }
        }
        const partnerId = ref(null);
        watch(partnerId, () => {
            citizens.fetch(partnerId.value ? apiCitizens.getForPartner(partnerId.value) : apiCitizens.getForNetwork()).catch(err => { notifyNetworkError("Failed to load citizens", err); });
            loadCitizenJoinUrl(partnerId.value);
        });
        // Search filter
        const showAll = ref(false);
        const { searchQuery, filtered: filteredCitizens, limited: limitedCitizens } = useFilterForAsync(citizens, (c) => `${c.displayName} ${c.username}`, LIMIT_SIZE);
        return (_ctx, _cache) => {
            const _component_SaveButton = _resolveComponent("SaveButton");
            const _component_LoadingTableRow = _resolveComponent("LoadingTableRow");
            const _component_CitizenBadge = _resolveComponent("CitizenBadge");
            const _component_OpenTasksIndicator = _resolveComponent("OpenTasksIndicator");
            const _component_router_link = _resolveComponent("router-link");
            const _component_PartnerBadge = _resolveComponent("PartnerBadge");
            const _component_SiteBadge = _resolveComponent("SiteBadge");
            const _component_UserBadge = _resolveComponent("UserBadge");
            return (_unref(isFeatureEnabled)('CITIZENS'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            (_unref(isNetworkAdmin)())
                                ? (_openBlock(), _createBlock(PartnerSelectField, {
                                    key: 0,
                                    modelValue: partnerId.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((partnerId).value = $event)),
                                    allowSelectAll: ""
                                }, null, 8, ["modelValue"]))
                                : _createCommentVNode("", true),
                            (citizenJoinUrl.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createElementVNode("a", {
                                        href: citizenJoinUrl.value,
                                        target: "_blank"
                                    }, [
                                        _createVNode(_component_SaveButton, {
                                            label: "Invite New Citizen",
                                            icon: "fa-plus"
                                        })
                                    ], 8, _hoisted_6)
                                ]))
                                : _createCommentVNode("", true),
                            _hoisted_7,
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "input",
                                            type: "text",
                                            placeholder: "Search",
                                            autofocus: "",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(searchQuery) ? (searchQuery).value = $event : null))
                                        }, null, 512), [
                                            [_vModelText, _unref(searchQuery)]
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("table", _hoisted_11, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _hoisted_12,
                                    (_unref(isNetworkAdmin)())
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_13, "Partner"))
                                        : _createCommentVNode("", true),
                                    _hoisted_14,
                                    (_unref(isPartnerAdmin)() || _unref(isNetworkAdmin)())
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_15, "Caseworker"))
                                        : _createCommentVNode("", true),
                                    _hoisted_16
                                ])
                            ]),
                            _createElementVNode("tbody", null, [
                                (_unref(isNetworkAdmin)() && partnerId.value == 'none')
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _hoisted_19))
                                    : (_unref(citizens).status == 'loading')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                                            _createVNode(_component_LoadingTableRow)
                                        ]))
                                        : (_unref(filteredCitizens).length == 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_21, _hoisted_23))
                                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList((showAll.value ? _unref(filteredCitizens) : _unref(limitedCitizens)), (citizen) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: citizen.id
                                                }, [
                                                    _createElementVNode("td", null, [
                                                        _createVNode(_component_router_link, {
                                                            to: `/citizens/${citizen.id}`,
                                                            class: "horizontal"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_CitizenBadge, { citizen: citizen }, null, 8, ["citizen"]),
                                                                _createVNode(_component_OpenTasksIndicator, {
                                                                    entityType: _unref(Core).EntityType['Citizen'],
                                                                    entityId: citizen.id
                                                                }, null, 8, ["entityType", "entityId"])
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["to"])
                                                    ]),
                                                    (_unref(isNetworkAdmin)())
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                                                            _createVNode(_component_router_link, {
                                                                to: `/citizens/${citizen.id}`
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_PartnerBadge, {
                                                                        partner: citizen.assignedCareProvider,
                                                                        noLink: ""
                                                                    }, null, 8, ["partner"])
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["to"])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("td", _hoisted_25, [
                                                        _createVNode(_component_router_link, {
                                                            to: `/citizens/${citizen.id}`
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (citizen.assignedSite)
                                                                    ? (_openBlock(), _createBlock(_component_SiteBadge, {
                                                                        key: 0,
                                                                        site: citizen.assignedSite,
                                                                        noLink: ""
                                                                    }, null, 8, ["site"]))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["to"])
                                                    ]),
                                                    (_unref(isPartnerAdmin)() || _unref(isNetworkAdmin)())
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                                                            _createVNode(_component_router_link, {
                                                                to: `/citizens/${citizen.id}`
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    (citizen.assignedCaseworker)
                                                                        ? (_openBlock(), _createBlock(_component_UserBadge, {
                                                                            key: 0,
                                                                            user: citizen.assignedCaseworker,
                                                                            noLink: ""
                                                                        }, null, 8, ["user"]))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["to"])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("td", null, [
                                                        _createVNode(_component_router_link, {
                                                            to: `/citizens/${citizen.id}`
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(formatDateShort)(citizen.registeredAt)), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["to"])
                                                    ])
                                                ]));
                                            }), 128)),
                                (_unref(citizens).status == 'ready' && _unref(filteredCitizens).length > LIMIT_SIZE && !showAll.value)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                                        _createElementVNode("td", _hoisted_29, [
                                            _createElementVNode("a", {
                                                onClick: _cache[2] || (_cache[2] = ($event) => (showAll.value = true))
                                            }, "Show All (" + _toDisplayString(_unref(filteredCitizens).length - LIMIT_SIZE) + " more)", 1)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
